import "./style.scss";
import * as react from "react";

interface IProps {
  children?: react.ReactNode;
}
export default function Popup(props: IProps) {
  return <div className="popup">{props.children}</div>;
}
